module.exports = __webpack_public_path__ + "static/media/L1.dbfb11b5.jpg";